import { pick } from 'ramda';
import type { Campaign } from 'c-sdk';
import { CampaignFormNames } from 'c-main/Types';

/**
 * What the campaign edit dialog's details form starts with. Older campaigns store linear as
 * `default`, which the type dropdown doesn't offer, so it starts as `linear`. Extracted from
 * `CampaignOverviewEdit`.
 */
export const campaignDetailsFormDefaults = (campaign: Campaign) => {
    const base = pick(['id', 'client_id', 'buyer_id', 'name', 'reference', 'type'], campaign);

    return {
        ...base,
        type: base?.type === 'default' ? 'linear' : base?.type,
        [CampaignFormNames.additional_contacts]: campaign?.additionalContacts?.map(c => c.id) ?? [],
    };
};
